import api from "./api";

export interface StoreRegistrationData {
  name: string;
  description: string;
  contact: string;
  category: string;
  latitude: number;
  longitude: number;
}

export async function registerStore(data: StoreRegistrationData): Promise<void> {
  await api().post("/store", data);
}
